/**
 * Map **route paths** to **feature_code** (from DB).
 * Keep this small object as your single source of truth for guarding pages.
 * Add entries as new pages get permissions.
 */
export const ROUTE_FEATURE_MAP: Record<string, string> = {
  "/dashboard": "dashboard",
  "/ideas": "ideas",
  "/scheduler": "scheduler",
  "/storage": "storage",
  "/comments": "comments",
  "/proposals": "proposals",
  "/concepts": "concepts",
  "/dashboard-settings": "dashboard.settings",
  "/dashboard/quicklinks": "dashboard.quicklinks",
  "/dashboard/activeitems": "dashboard.myactiveitems",
  "/dashboard/taskpriorities": "dashboard.taskpriorities",
  "/dashboard/keyguidelines": "dashboard.keyguidelines",
  "/dashboard/upcomingmeetings": "dashboard.upcomingmeetings",
  "/dashboard/impacttargets": "dashboard.impacttargets",
  "/dashboard/teamcalender": "dashboard.teamcalender",
  "/dashboard/partnerdirectory": "dashboard.partnerdirectory",
  "/dashboard/learninginsights": "dashboard.learninginsights",
  "/dashboard/analyticsinsights": "dashboard.analyticsinsights",
  "/dashboard/compas": "dashboard.compas",
  "/dashboard/programresources": "dashboard.programresources",
};
